import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import styles from './sprite-selector-add.css';
import iconFont from '../../css/iconfont.css';

const SpriteSelectorAdd = props => (
    <div
        className={styles.spriteSelectorAdd}
        onClick={props.onClick}
    >
        <i className={classNames(iconFont.iconfont, iconFont.iconTianjia)} />
        <div
            className={styles.title}
        >
            <FormattedMessage
                defaultMessage="New Sprite"
                description="Button to open sprite library"
                id="gui.targetPanel.AddSprite"
            />
        </div>
    </div>
);

SpriteSelectorAdd.propTypes = {
    onClick: PropTypes.func
};

export default SpriteSelectorAdd;
